export const header = ()=> {
    return {
        'Content-Type': 'application/json',
        'Authorization' : 'Bearer ' + JSON.parse(sessionStorage.getItem("oidc.user:")).access_token 
    }
} 
